@if (product() && product().presentation) {
    <app-json-ld [json]="schema()"></app-json-ld>
    <!-- #region price and logo -->
    <div class="grid-container">
        @if (!product().orderConfig.hasFlexPrice || product().orderConfig.showPriceFrom) {
            <div class="g-6 m-12:b md:m-16:b lg:m-24:b">
                <span class="h4 product-hint">
                    {{ settlementPeriod() === 'year' ? 'Jährlich' : 'Monatlich' }}
                    {{ product().orderConfig.showPriceFrom ? ' ab' : '' }}
                </span>
                <!-- prettier-ignore -->
                <app-display-price [price]="displayPrice()"></app-display-price>
                <span class="product-tax-details">{{ product().orderConfig.taxInfo }}</span>
            </div>
        }
    </div>
    <div class="clearer"></div>
    <!-- #endregion -->

    <!-- #region product description -->
    <div [innerHTML]="product().presentation.description"></div>
    <!-- #endregion -->

    <!-- #region product documents -->
    <p>
        Hier kannst du das
        <a
            [href]="'/assets/documents/' + product().presentation.docIPIDUrl"
            target="_blank"
            rel="noreferrer noopener"
            title="Informationsblatt zu Versicherungsprodukten (PDF)"
            >Informationsblatt zu Versicherungsprodukten (PDF)</a
        >, die
        <a
            [href]="'/assets/documents/' + product().presentation.docAVBUrl"
            target="_blank"
            rel="noreferrer noopener"
            title="Allgemeine Versicherungsbedingungen (PDF)"
            >Allgemeinen Versicherungsbedingungen (PDF)</a
        >, das
        <a
            [href]="'/assets/documents/' + product().presentation.docAnzeigepflichtUrl"
            target="_blank"
            rel="noreferrer noopener"
            title="Informationsblatt zu Obliegenheiten und Anzeigepflicht (PDF)"
            >Informationsblatt zu Obliegenheiten und Anzeigepflicht (PDF)</a
        >
        und die
        <a
            [href]="'/assets/documents/' + product().presentation.docAddInfoUrl"
            target="_blank"
            rel="noreferrer noopener"
            title="Weitere Kundeninformationen (PDF)"
            >weiteren Kundeninformationen (PDF)</a
        >
        einsehen.
    </p>
    <!-- #endregion -->

    <!-- #region product side bar info box -->
    <div class="md:hide m-24:t md:m-32:t lg:m-48:t">
        @if (product().presentation.bulletPoints) {
            <app-info-box
                headline="Deine Vorteile"
                [bulletPoints]="product().presentation.bulletPoints"
            >
                @if (showCustomerServiceNumber()) {
                    <h3 class="c:blue-700 m-12:t md:m-16:t lg:m-24:t fw:regular">Beratungsservice:</h3>
                    <p><strong>0621&nbsp;1247682-0</strong></p>
                }
            </app-info-box>
        }
    </div>
    <!-- #endregion -->

    <!-- #region navigation -->
    <div class="grid-container p-24:t md:p-32:t lg:p-48:t">
        @if (!availableForUser()) {
            <div class="g-12 m-24:b md:m-32:b lg:m-48:b">
                <div class="bg:grey-5 p-12 md:p-16 lg:p-24">
                    <h4 class="c:red align:c">
                        Das von dir gewünschte Produkt können nur natürliche Personen, nicht aber juristische Personen
                        wie Schulen, Vereine oder Firmen beantragen.
                    </h4>
                    <p class="align:c c:headline">
                        <button
                            type="button"
                            class="btn-link"
                            (click)="logout()"
                        >
                            Bitte melde dich ab</button
                        >, um fortzufahren
                    </p>
                </div>
            </div>
        }
        <div class="g-12 md:g-8">&nbsp;</div>
        <div class="g-12 md:g-4">
            <button
                type="button"
                class="button next"
                (click)="submit()"
                [disabled]="!availableForUser()"
            >
                Weiter
            </button>
        </div>
    </div>
    <!-- #endregion -->
}
